import { useCallback, useMemo } from "react";

import { useObjectMemo } from "../../../hooks";
import { useNarmiTiles } from "../../entities";

import { useTileAuthorization } from "./requests";

export const useTiles = () => {
  const tiles = useNarmiTiles();
  return tiles;
};

export const useTile = (tile: API.NarmiTile) => {
  const { getAuthorization } = useTileAuthorization(tile);

  const refreshAuthorization = useCallback(async () => {
    const authorizationCode = await getAuthorization();
    return authorizationCode;
  }, [getAuthorization]);

  const redirectUri = useMemo(() => {
    let uri = tile.redirect_uris;
    if (uri.includes("/index.html")) {
      uri = uri.replace("/index.html", "/tile.html");
    } else {
      const trailingSlashRemoved = uri.replace(/\/$/, "");
      uri = `${trailingSlashRemoved}/tile`;
    }
    return uri;
  }, [tile.redirect_uris]);

  return useObjectMemo({
    redirectUri,
    refreshAuthorization,
  });
};
